module.exports = __webpack_public_path__ + "static/media/success.c2dc8fab.svg";